import { Component, ReactNode, ReactNodeArray } from 'react';
import { createPortal } from 'react-dom';
import { getScrollBarSize, isServerSideRendering } from '@carvana/futilities';

type PortalProps = {
  children: ReactNode | ReactNodeArray;
  open: boolean;
  rootClassname: string;
};

class Portal extends Component<PortalProps> {
  bodyElem?: HTMLElement;

  modalContainer?: Element;

  constructor(props) {
    super(props);
    if (isServerSideRendering()) { return; }
    this.bodyElem = document.body;
    this.modalContainer = document.createElement('div');
    this.modalContainer.classList.add(props.rootClassname);
  }

  componentDidMount() {
    if (isServerSideRendering()) { return; }
    const { open } = this.props;
    if (open) {
      this.open();
    }
  }

  componentDidUpdate(prevProps) {
    if (isServerSideRendering()) { return; }
    const { open } = this.props;
    if (!prevProps.open && open) {
      this.open();
    }
    if (prevProps.open && !open) {
      this.close();
    }
  }

  componentWillUnmount() {
    if (isServerSideRendering()) { return; }
    const { open } = this.props;
    if (open) {
      this.close();
    }
  }

  close() {
    if (!this.bodyElem || !this.modalContainer) return;

    this.bodyElem.style.removeProperty('overflow');
    this.bodyElem.style.removeProperty('padding-right');
    if (this.bodyElem.contains(this.modalContainer)) {
      this.bodyElem.removeChild(this.modalContainer);
    }
  }

  open() {
    if (!this.bodyElem || !this.modalContainer) return;

    const size = getScrollBarSize();
    this.bodyElem.style.overflow = 'hidden';
    this.bodyElem.style.paddingRight = `${size}px`;
    this.bodyElem.appendChild(this.modalContainer);
  }

  render() {
    const { children, open } = this.props;
    const shouldRenderPortal = open && !isServerSideRendering();
    return shouldRenderPortal ?
      createPortal(children, this.modalContainer)
      : null;
  }
}

export default Portal;
